import { CALL_API } from '../middleware/api';
import {
    GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST,
    GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS,
    GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE,
} from './actionTypes';
import SketchAdminSketchOrderClient from '../lib/apiClients/roofSnapApiClient/sketchAdminSketchOrderClient';

export const getNotifications = (sketchOrderId) => {
    const client = new SketchAdminSketchOrderClient('v2');
    const request = client.getNotifications;
    const params = {
        sketchOrderId,
    }
    return {
        [CALL_API]: {
            types: [
                GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST,
                GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS,
                GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE,
            ],
            request,
            params,
        }
    }
};
